import { render } from "./user_total.vue?vue&type=template&id=c728eb2e&scoped=true"
import script from "./user_total.vue?vue&type=script&lang=js"
export * from "./user_total.vue?vue&type=script&lang=js"

import "./user_total.vue?vue&type=style&index=0&id=c728eb2e&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c728eb2e"]])

export default __exports__